import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'
import { validateVineyards, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import { getErrorsApiToReduxForm } from '../utils/utils.js';
import VineyardsForm from '../components/VineyardsForm';
import validate from '../components/Validations/submitValidationsVineyardsForm';
const mapStateToProps = (state) => {
    return {
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSubmit(values, dispatch) {
            dispatch(submitForm());
            let errors = validate(values);
            if( Object.keys(errors).length === 0){
            return dispatch(validateVineyards(values)).then((result) => {
                if (result.payload.status !== 200) {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError ({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá el código de los viñedos ingresados.'});
                } else {
                    dispatch(getNextStep()).then((result) => {
                        if (typeof(result.payload.data.endpoint) !== 'undefined') {
                            sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                            dispatch(stopSubmitForm());
                            browserHistory.push(result.payload.data.endpoint);
                        }
                    });
                }
            });
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VineyardsForm);



/** WEBPACK FOOTER **
 ** ./src/containers/VineyardsContainer.js
 **/